var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3089_12924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0017 0C35.8869 0 0 35.8869 0 80.0017C0 124.116 35.8869 160.003 80.0017 160.003C124.116 160.003 160.003 124.116 160.003 80.0017C160.003 35.8869 124.113 0 80.0017 0ZM80.0017 141.46C46.1127 141.46 18.5402 113.891 18.5402 79.9983C18.5402 46.1061 46.1094 18.5402 80.0017 18.5402C113.894 18.5402 141.463 46.1127 141.463 80.0017C141.463 113.891 113.891 141.463 80.0017 141.463V141.46Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.681 70.209H89.2524V49.7805C89.2524 44.6776 85.1002 40.5254 79.9973 40.5254C74.8943 40.5254 70.7422 44.6776 70.7422 49.7805V70.209H50.3137C45.2108 70.209 41.0586 74.3611 41.0586 79.4641C41.0586 84.567 45.2108 88.7192 50.3137 88.7192H70.7422V109.148C70.7422 114.251 74.8943 118.403 79.9973 118.403C85.1002 118.403 89.2524 114.251 89.2524 109.148V88.7192H109.681C114.784 88.7192 118.936 84.567 118.936 79.4641C118.936 74.3611 114.784 70.209 109.681 70.209Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3089_12924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.6f4faba1.svg";
export { ForwardRef as ReactComponent };